import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const path = '../oldPages/user-management/single-user/index.html';

const links: Record<string, string> = {
  users: '/infoTrac/user-management',
  roles: '/infoTrac/user-management/roles',
  apps: '/infoTrac/user-management/apps',
  createNewUser: '/infoTrac/user-management/create-user',
  roleSettings: '/infoTrac/user-management/roles',
  trustedBrowsers: '/infoTrac/user-management/trusted-browsers',
  manageAlerts: '/infoTrac/user-management/manage-alerts',
};

function UserManagementSingleUser() {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleIframeLoad = () => {
      const iframeDocument = iframeRef.current?.contentDocument || iframeRef.current?.contentWindow?.document;

      if (!iframeDocument) return;

      const users = iframeDocument.getElementById('users');
      const roles = iframeDocument.getElementById('roles');
      const apps = iframeDocument.getElementById('apps');

      const submit = iframeDocument.getElementById('submitbtn');
      const createNew = iframeDocument.getElementById('createNewUser');
      const roleSettings = iframeDocument.getElementById('role-settings');
      const trustedBrowsers = iframeDocument.getElementById('trusted-browsers');
      const manageAlerts = iframeDocument.getElementById('manage-alerts');

      if (users) users.addEventListener('click', () => navigate(links.users));
      if (roles) roles.addEventListener('click', () => navigate(links.roles));
      if (apps) apps.addEventListener('click', () => navigate(links.apps));

      if (submit) submit.addEventListener('click', () => navigate(links.users));
      if (createNew) createNew.addEventListener('click', () => navigate(links.createNewUser));
      if (roleSettings) roleSettings.addEventListener('click', () => navigate(links.roleSettings));
      if (trustedBrowsers) trustedBrowsers.addEventListener('click', () => navigate(links.trustedBrowsers));
      if (manageAlerts) manageAlerts.addEventListener('click', () => navigate(links.manageAlerts));
    };

    if (iframeRef.current) iframeRef.current.addEventListener('load', handleIframeLoad);

    return () => {
      if (iframeRef.current) iframeRef.current.removeEventListener('load', handleIframeLoad);
    };
  }, []);

  return <iframe ref={iframeRef} title="user-management-single-user" src={path} width="100%" height="700px" />;
}

export default UserManagementSingleUser;
